import { useEffect, useState } from 'react';
import { Stack, Checkbox, Textarea, Text, Card } from '@mantine/core';
import api from '@/api/api';
import { displayError } from '@/utils/error/errorHandler';

interface CareRequirement {
  id: number;
  name?: string;
}

interface CareRequirementsCardProps {
  formContext: any;
  disabled?: boolean;
}

export const CareRequirementsCard = (props: CareRequirementsCardProps) => {
  const [careRequirements, setCareRequirements] = useState<CareRequirement[]>(
    []
  );
  const form = props.formContext();

  useEffect(() => {
    const fetchCareRequirements = async () => {
      try {
        const response = await api.get('/applicants/care-requirements');
        setCareRequirements(response.data);
      } catch (error) {
        displayError(error);
      }
    };

    fetchCareRequirements();
  }, []);

  return (
    <div>
      <Card shadow="sm" padding="md" radius="md" withBorder>
        <Text fw={700} size="large">
          Požadavky zájemce
        </Text>
        <Stack className="mt-2">
          {careRequirements.map(requirement => (
            <Checkbox
              key={requirement.id}
              label={requirement.name}
              checked={form.values.careReq.some(
                (item: number) => item === requirement.id
              )}
              onChange={event => {
                const currentValues: number[] = form.values.careReq ?? [];

                if (event.currentTarget.checked) {
                  const newValue: number[] = [...currentValues, requirement.id];
                  form.setFieldValue('careReq', newValue);
                } else {
                  const newValue: number[] = currentValues.filter(
                    (item: number) => item !== requirement.id
                  );
                  form.setFieldValue('careReq', newValue);
                }
              }}
              disabled={props.disabled}
              data-testid={`care-req-checkbox-${requirement.id}`}
            />
          ))}
          <Textarea
            variant="filled"
            autosize
            minRows={2}
            maxRows={6}
            placeholder="Detaily k požadavkům zájemce"
            {...form.getInputProps('note')}
            disabled={props.disabled}
            data-testid="care-req-note"
          />
        </Stack>
      </Card>
    </div>
  );
};
